import React from 'react';

import { AIAgentRouter } from './AIAgentRouter';
import { useResizableSidebar } from '../collections/hooks/useResizableSidebar';

/**
 * Parent wrapper component that manages sidebar state for AI Agent module
 * This component lifts the sidebar state up to avoid re-rendering the entire router
 * when only sidebar toggle functionality is needed in child components
 */
export const AIAgentWithSidebar: React.FC = () => {
  const sidebarControls = useResizableSidebar<'insights'>({
    initialOpenSidebar: 'insights',
    storageKey: 'ai-agent-sidebar-state',
  });

  return <AIAgentRouter sidebarControls={sidebarControls} />;
};
